var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage organizations")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/admin/organizations/users/manage/organization`,
                  expression:
                    "`/#/admin/organizations/users/manage/organization`",
                },
              ],
              staticClass: "btn btn-link btn-sm",
              attrs: { type: "button" },
            },
            [
              _c("i", {
                staticClass: "fa fa-exchange",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Change user's organization")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/admin/organizations/users/manage/roles`,
                  expression: "`/#/admin/organizations/users/manage/roles`",
                },
              ],
              staticClass: "btn btn-link btn-sm",
              attrs: { type: "button" },
            },
            [
              _c("i", {
                staticClass: "fa fa-user-secret",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Assign Global Admin")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-success text-white",
              staticStyle: { padding: "0.7em 2em" },
              attrs: { href: `/#/admin/organizations/create`, role: "button" },
            },
            [
              _c("i", {
                staticClass: "fa fa-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("New organization")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container", staticStyle: { "margin-bottom": "40px" } },
      [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.organizations, function (o) {
            return _c(
              "div",
              {
                key: o.OrganizationUnitId,
                staticClass: "col-md-4 col-sm-6",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("div", { staticClass: "card bg-light" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: `/#/admin/organizations/dashboard/${o.OrganizationUnitId}`,
                        },
                      },
                      [_vm._v(_vm._s(o.Name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("p", { staticClass: "card-text" }, [
                      _vm._v(_vm._s(o.Description || "No description")),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                            Admins count: " +
                          _vm._s(o.AdminsCount)
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "card-link",
                          attrs: {
                            href: `/#/admin/organizations/users/createorganizationadmin/${o.OrganizationUnitId}`,
                          },
                        },
                        [_vm._v("Set up admin")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }